import { useContext } from 'react'

import { BrandRankingContext } from './context'

export const useBrandRanking = () => {
  const context = useContext(BrandRankingContext)

  if (!context) {
    throw new Error('useBrandRanking must be used within an BrandRankingProvider')
  }

  return context
}
